import { render, staticRenderFns } from "./BasePhoneNumberInput.vue?vue&type=template&id=31e7dd0b"
import script from "./BasePhoneNumberInput.vue?vue&type=script&lang=js"
export * from "./BasePhoneNumberInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports